import ActionBarItem from '@rio-cloud/rio-uikit/ActionBarItem';
import { useUikitContext } from '../UikitContext';

export const MenuToggle = () => {
    const { onMenuIconClicked } = useUikitContext();

    return (
        <ActionBarItem id='menuToggle'>
            <ActionBarItem.Icon onClick={onMenuIconClicked}>
                <span className='UikitMenuToggle icon rioglyph rioglyph-menu-hamburger' />
            </ActionBarItem.Icon>
        </ActionBarItem>
    );
};
